const breakpoints = ['480px', '576px', '768px', '992px', '1200px', '1600px'];

const colors = {
  primary: '#1890ff',
  primaryLight: '#40a9ff',
  primaryBorder: '#d9d9d9',
};

const fontFamily = 'Arial';

export const theme = {
  breakpoints,
  colors,
  fontFamily,
};
